export default __webpack_public_path__ + "static/media/USezpay.491fda00.svg";